import { Breadcrumb, type BreadcrumbProps } from '@chakra-ui/react';

export type UiBreadcrumbProps = BreadcrumbProps;

export const UiBreadcrumb = Breadcrumb;
